<template>
  <div v-if="!tabLoading" class="grid grid--rev" style="max-width: 960px;">
    <div class="grid__cell 7/12--large-up">
      <DraggableInputContent namespace="settings/tiers" name="Tier" />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import DraggableInputContent from '@/components/DesignSystem/DraggableInput/DraggableInputContent';
const { mapActions } = createNamespacedHelpers('settings/tiers');

export default {
  components: {
    DraggableInputContent,
  },
  methods: {
    ...mapActions(['fetchTiers', 'clearItems']),
  },
  computed: {
    tabLoading() {
      return this.$store.getters['tabLoading'];
    },
  },
  created() {
    this.clearItems();
    // this.fetchTiers();
  },
};
</script>
